// ---------------------------------------------------------------------------
// Audit export (issue #876)
// ---------------------------------------------------------------------------

import type { AuditEventFilter } from '../../graphql/types';
import { apiRequest } from './http';

/**
 * Result of a successful audit export request — a short-lived signed URL for
 * the generated CSV/JSON file, not the file content itself.
 */
export interface AuditExportResult {
  url: string;
  expiresAt: string;
  key: string;
  eventCount: number;
}

/**
 * POST /api/v1/audit/export
 *
 * Requests a signed export URL for the given filter/format. Routed through
 * `apiRequest` (not `downloadFile`) because this endpoint is a POST with a
 * JSON body that returns `{ url }` rather than a downloadable file body —
 * the caller opens the returned URL directly (see routes/audit/index.tsx).
 * `apiRequest` supplies the absolute `API_BASE_URL` and the `Authorization:
 * Bearer` header that a bare `fetch('/api/v1/audit/export')` lacked (#876).
 */
export async function exportAuditLog(
  filter: AuditEventFilter,
  format: 'csv' | 'json'
): Promise<AuditExportResult> {
  return apiRequest<AuditExportResult>('/audit/export', {
    method: 'POST',
    body: JSON.stringify({ filter, format }),
  });
}
